import { Listbox } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

const AssessmentDropdown = ({
  icon,
  title,
  description,
  value,
  setValue,
  options,
}) => {
  return (
    <div className="flex items-start">
      {/* ICON + TEXT */}
      <div className="flex items-start">
        <img src={icon} alt="" className="w-6 assessment-icon" />

        <div className="ml-2">
          <h4 className="text-[10px] font-semibold text-white mb-1 leading-3">
            {title}
          </h4>
          <p className="flex-1 text-[0.5625rem] text-white/70 leading-3 mb-2">
            {description}
          </p>
        </div>
      </div>

      {/* HEADLESS UI DROPDOWN */}
      <Listbox value={value} onChange={setValue}>
        <div className="relative">
          {/* BUTTON */}
          <Listbox.Button className="bg-[#E7E4E4] text-black px-1 h-5 rounded-[7px] flex items-center justify-between min-w-[78px]">
            <span className="text-[7px] text-black">{value}</span>
            <ChevronDownIcon className="w-4 h-4 text-black opacity-70" />
          </Listbox.Button>

          {/* OPTIONS */}
          <Listbox.Options className="absolute right-0 mt-1 w-20 pt-2 pb-1 bg-[#fff] text-black shadow-lg rounded-lg overflow-hidden z-50">
            {options.map((opt, idx) => (
              <Listbox.Option
                key={idx}
                value={opt}
                className="cursor-pointer px-2 mb-1 text-[7px] hover:bg-white/10"
              >
                {opt}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </div>
      </Listbox>
    </div>
  );
};

export default AssessmentDropdown;
